/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum OrderStatusEnum {
    "print_proof_review" = "print_proof_review",
    "fulfilled" = "fulfilled",
    "pending" = "pending"
}

export type OrderStatus = OrderStatusEnum;